const serviceTypeList = [{
        value: 1,
        text_en: 'Kinds',
        text_bn: 'দ্রব্যাদি'
    },
    {
        value: 2,
        text_en: 'Financial',
        text_bn: 'আর্থিক'
    }
]

const admissionTypeList = [{
        id: 1,
        name: 'Indoor',
        name_bn: 'ইনডোর'
    },
    {
        id: 2,
        name: 'Outdoor',
        name_bn: 'আউটডোর'
    }
]

const serviceOfficerComentList = [{
    id: 1,
    name: 'After verifying the patient`s information, assistance was provided from the Patient Welfare Association as the patient was unable to afford the medical expenses',
    name_bn: 'রোগীর তথ্য যাচাইপূর্বক চিকিৎসা ব্যয় বহনে অসমর্থ হওয়ায় রোগীকল্যাণ সমিতি থেকে সহায়তা প্রদান করা হলো'
},
{
    id: 2,
    name: 'other',
    name_bn: 'অন্যান্য'
}
]

const outExpenseList = [{
    value: 2,
    text_en: 'Goods and Materials',
    text_bn: 'মালামাল ও উপকরণ'
},
{
    value: 3,
    text_en: 'Miscellaneous',
    text_bn: 'বিবিধ'
}
]

const referList = [{
        id: 1,
        name: 'Through the police',
        name_bn: 'পুলিশের মাধ্যমে'
    },
    {
        id: 2,
        name: 'By pedestrians',
        name_bn: 'পথচারীর মাধ্যমে'
    },
    {
        id: 3,
        name: 'Through hospital authorities',
        name_bn: 'হাসপাতাল কর্তৃপক্ষের মাধ্যমে'
    },
    {
        id: 4,
        name: 'other',
        name_bn: 'অন্যান্য'
    }
]

const importTypeList = [{
        id: 0,
        value: 0,
        text: 'Registered ',
        text_en: 'Registered ',
        text_bn: 'রেজিস্টার্ড'
    },
    {
        id: 1,
        value: 1,
        text: 'Imported',
        text_en: 'Imported',
        text_bn: 'ইম্পোর্টেড'
    }
]

const consultancyReportTypeList = [{
        id: 1,
        value: 1,
        text_en: 'Monthly Disability Report',
        text_bn: 'মাসিক প্রতিবন্ধী প্রতিবেদন'
    },
    {
        id: 2,
        value: 2,
        text_en: 'Yearly Registered Report',
        text_bn: 'বার্ষিক নিবন্ধিত প্রতিবেদন'
    },
    {
        id: 3,
        value: 3,
        text_en: 'Yearly Service Delivered Report',
        text_bn: 'বার্ষিক সার্ভিস বিতরণ প্রতিবেদন'
    },
    {
        id: 4,
        value: 4,
        text_en: 'Center Wise Report',
        text_bn: 'কেন্দ্র ভিত্তিক প্রতিবেদন'
    }
]

const deliTypList = [{
        id: 1,
        value: 1,
        name: 'Cash',
        name_bn: 'নগদ অর্থ'
    },
    {
        id: 2,
        value: 2,
        name: 'Kinds',
        name_bn: 'দ্রব্যাদি'
    }
]

const kindsDeliTypList = [{
        id: 1,
        value: 1,
        name: 'Purchased from association funds',
        name_bn: 'সমিতির তহবিল থেকে ক্রয় করে'
    },
    {
        id: 2,
        value: 2,
        name: 'From stocks received from donors',
        name_bn: 'ডোনার থেকে প্রাপ্ত মজুদ থেকে'
    }
]

const amountFmList = [{
        id: 1,
        value: 1,
        name: 'BNSWC Fund',
        name_bn: 'জাতীয় সমাজকল্যাণ পরিষদ তহবিল'
    },
    {
        id: 3,
        value: 3,
        name: 'Burn Fund',
        name_bn: 'দগ্ধ তহবিল'
    },
    {
        id: 4,
        value: 4,
        name: 'Zakat Fund',
        name_bn: 'যাকাত তহবিল'
    },
    {
        id: 2,
        value: 2,
        name: 'Donation And Other Fund',
        name_bn: 'দান ও অন্যান্য তহবিল'
    }
]

const payModeList = [{
        id: 1,
        value: 1,
        name: 'Hand Cash',
        name_bn: 'হ্যান্ড ক্যাশ'
    },
    {
        id: 2,
        value: 2,
        name: 'MFS',
        name_bn: 'এমএফএস'
    }
]

const mobileBankingList = [{
        id: 1,
        value: 1,
        name: 'Bkash',
        name_bn: 'বিকাশ'
    },
    {
        id: 2,
        value: 2,
        name: 'Rocket',
        name_bn: 'রকেট'
    },
    {
        id: 3,
        value: 3,
        name: 'Nagad',
        name_bn: 'নগদ'
    }
]

const bloodGroupList = [
    {
        value: 1,
        text_en: 'A+',
        text_bn: 'A+'
    },
    {
        value: 2,
        text_en: 'A-',
        text_bn: 'A-'
    },
    {
        value: 3,
        text_en: 'B+',
        text_bn: 'B+'
    },
    {
        value: 4,
        text_en: 'B-',
        text_bn: 'B-'
    },
    {
        value: 5,
        text_en: 'O+',
        text_bn: 'O+'
    },
    {
        value: 6,
        text_en: 'O-',
        text_bn: 'O-'
    },
    {
        value: 7,
        text_en: 'AB+',
        text_bn: 'AB-'
    },
    {
        value: 8,
        text_en: 'AB-',
        text_bn: 'AB-'
    }
]

const centerTypeList = [{
        id: 1,
        value: 1,
        text_en: 'PSOSK',
        text_bn: 'পিএসওএসকে'
    },
    {
        id: 2,
        value: 2,
        text_en: 'MTV',
        text_bn: 'এমটিভি'
    }
]

const hospitalCategoryList = [{
        id: 1,
        name: 'Medical College Hospital',
        name_bn: 'মেডিকেল কলেজ হাসপাতাল'
    },
    {
        id: 2,
        name: 'Specialized Hospital',
        name_bn: 'বিশেষায়িত হাসপাতাল'
    },
    {
        id: 3,
        name: 'General Hospital',
        name_bn: 'জেনারেল হাসপাতাল'
    },
    {
        id: 4,
        name: 'Upazila Health Complex',
        name_bn: 'উপজেলা হেলথ কমপ্লেক্স'
    },
    {
        id: 5,
        name: 'Hospital included for 30% service',
        name_bn: '৩০% সেবার জন্য অন্তর্ভুক্ত হাসপাতাল'
    }
]

const hospitalClassList = [{
        id: 1,
        value: 1,
        text_en: 'Government',
        text_bn: 'সরকারি'
    },
    {
        id: 2,
        value: 2,
        text_en: 'Private',
        text_bn: 'বেসরকারি'
    }
]

const pMdList = [{
        id: 1,
        value: 1,
        name: 'Hand Cash',
        name_bn: 'হ্যান্ড ক্যাশ'
    },
    {
        id: 2,
        value: 2,
        name: 'MFS',
        name_bn: 'এমএফএস'
    }
]

const memberTypeList = [{
    value: 1,
    text_en: 'General Member',
    text_bn: 'সাধারণ সদস্য'
},
{
    value: 2,
    text_en: 'Lifetime Member',
    text_bn: 'আজীবন সদস্য'
},
{
    value: 3,
    text_en: 'Donor member',
    text_bn: 'দাতা সদস্য'
},
{
    value: 4,
    text_en: 'Institutional member',
    text_bn: 'প্রাতিষ্ঠানিক সদস্য'
}
]

const subServiceTypeList = [
    {
        value: 1,
        text_en: 'Medicine',
        text_bn: 'ঔষধ'
    },
    {
        value: 2,
        text_en: 'Medical Test',
        text_bn: 'পরীক্ষা-নিরীক্ষা'
    },
    {
        value: 3,
        text_en: 'Clothing And Other',
        text_bn: 'বস্ত্র'
    },
    {
        value: 4,
        text_en: 'Blood',
        text_bn: 'রক্ত'
    },
    {
        value: 5,
        text_en: 'Glass',
        text_bn: 'চশমা'
    },
    {
        value: 6,
        text_en: 'Milk/ Food',
        text_bn: 'দুধ/ পথ্য/ খাদ্য'
    },
    {
        value: 7,
        text_en: 'Dialysis',
        text_bn: 'ডায়ালাইজার'
    },
    {
        value: 9,
        text_en: 'Fares for transportation',
        text_bn: 'যাতায়াত ভাড়া'
    },
    {
        value: 10,
        text_en: 'Transportation of corpses/ Funeral etc',
        text_bn: 'লাশ পরিবহন/ মৃতের সৎকার ইত্যাদি'
    },
    {
        value: 11,
        text_en: 'Wheelchair/ Crutch',
        text_bn: 'হুইল চেয়ার/ ক্রাচ'
    },
    {
        value: 12,
        text_en: 'Artificial Arms',
        text_bn: 'কৃত্রিম অঙ্গ'
    },
    {
        value: 13,
        text_en: 'Therapy',
        text_bn: 'থেরাপি'
    },
    {
        value: 8,
        text_en: 'Other (If any other service required write in description)',
        text_bn: 'অন্যান্য (অন্য কোন সেবা থাকলে বিবরণে লিখুন)'
    }
]

const patientTypeList = [
    {
        value: 1,
        text_en: 'Registered',
        text_bn: 'রেজিস্টার্ড'
    },
    {
        value: 2,
        text_en: 'New',
        text_bn: 'নতুন'
    }
]

const donationTypeList = [{
        id: 1,
        value: 1,
        text_en: 'Financial',
        text_bn: 'আর্থিক'
    },
    {
        id: 1,
        value: 2,
        text_en: 'Kinds',
        text_bn: 'দ্রব্যাদি'
    }
]

const donationTypeForList = [{
        value: 1,
        text_en: 'Disability',
        text_bn: 'অক্ষমতা'
    },
    {
        value: 2,
        text_en: 'Burn Victim',
        text_bn: 'দগ্ধ ব্যক্তি'
    },
    {
        value: 3,
        text_en: 'zakat',
        text_bn: 'যাকাত'
    }
]

const accountTypeList = [{
        value: 1,
        text_en: 'Current',
        text_bn: 'চলতি'
    },
    {
        value: 2,
        text_en: 'Savings',
        text_bn: 'সঞ্চয়ী'
    }
]

const depositTypeList = [{
        value: 1,
        text_en: 'Cash',
        text_bn: 'নগদ অর্থ'
    },
    {
        value: 2,
        text_en: 'Cheque',
        text_bn: 'চেক'
    }
]
const socialServiceDeliveryList = [{
        value: 1,
        text_en: 'DSS',
        text_bn: 'সমাজকল্যাণ মন্ত্রণালয়াধীন সেবার মাধ্যমে'
    },
    {
        value: 2,
        text_en: 'Donor',
        text_bn: 'রোগীকল্যাণ সমিতির অর্থ সহায়তার মাধ্যমে'
    }
]
const rehabilitationInstituteList = [{
        value: 1,
        text_en: 'Govt Child Family',
        text_bn: 'সরকারী শিশু পরিবার'
    },
    {
        value: 2,
        text_en: 'Chhotamani Nibas',
        text_bn: 'ছোটমনি নিবাস'
    },
    {
        value: 3,
        text_en: 'Shelter',
        text_bn: 'আশ্রয়কেন্দ্র'
    },
    {
        value: 4,
        text_en: 'National Disability Development Foundation',
        text_bn: 'জাতীয় প্রতিবন্ধী উন্নয়ন ফাউন্ডেশন'
    },
    {
        value: 5,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const identityTypeList = [{
        value: 1,
        text_en: 'NID',
        text_bn: 'এনআইডি'
    },
    {
        value: 2,
        text_en: 'Birth Registration no',
        text_bn: 'জন্ম নিবন্ধন নং'
    }
]

const reportDurationList = [{
        value: 1,
        text_en: 'Monthly',
        text_bn: 'মাসিক'
    },
    {
        value: 2,
        text_en: 'Yearly',
        text_bn: 'বার্ষিক'
    }
]

const progressReportTypeList = [{
        value: 1,
        text_en: 'Numeric',
        text_bn: 'সংখ্যাগত'
    },
    {
        value: 2,
        text_en: 'Financial',
        text_bn: 'আর্থিক'
    }
]

const socialServiceCategoryList = [{
    value: 1,
    text_en: 'Counseling And Motivation',
    text_bn: 'উদ্বুদ্ধকরণ/কাউন্সেলিং'
},
{
    value: 2,
    text_en: 'Recreation (TV/Newspapers/Books/Magazines/Playground etc.)',
    text_bn: 'চিত্তবিনোদন(টিভি/পত্রিকা/বই/ম্যাগাজিন/শিশু খেলাঘর ইত্যাদি)'
},
{
    value: 4,
    text_en: 'Social Awareness Activities(Plays/Advertisements/Leaflet Distribution etc.)',
    text_bn: 'সামাজিক সচেতনতা কার্যক্রম(পথনাটক/বিজ্ঞাপন/লিফলেট বিতরণ ইত্যাদি)'
}
]

const socialServiceNameList = [{
    value: 2,
    text_en: 'Primary Health Care and Nutrition',
    text_bn: 'প্রাথমিক স্বাস্থ্য পরিচর্যা ও পুষ্টি'
},
{
    value: 3,
    text_en: 'Family Planning',
    text_bn: 'পরিবার পরিকল্পনা গ্রহণ'
},
{
    value: 4,
    text_en: 'Regular Medication Intake',
    text_bn: 'নিয়মিত ঔষধ সেবন'
},
{
    value: 5,
    text_en: 'Mental Comfort',
    text_bn: 'মানসিক সান্ত্বনা'
},
{
    value: 6,
    text_en: 'Other',
    text_bn: 'অন্যান্য'
}
]
const vanConditionlist = [
{
    value: 1,
    text: 'Under Repair',
    text_en: 'Under Repair',
    text_bn: 'মেরামত প্রক্রিয়াধীন'
},
{
    value: 2,
    text: 'Active',
    text_en: 'Active',
    text_bn: 'সচল'
},
{
    value: 3,
    text: 'Seriously Damaged',
    text_en: 'Seriously Damaged',
    text_bn: 'গুরুতর নষ্ট'
}
]
const equipmentTypeList = [{
    value: 1,
    text: 'Manual Therapy Equipment',
    text_en: 'Manual Therapy Equipment',
    text_bn: 'ম্যানুয়াল থেরাপি যন্ত্রপাতি'
},
{
    value: 2,
    text: 'Electro Therapy Equipment',
    text_en: 'Electro Therapy Equipment',
    text_bn: 'ইলেক্ট্রো থেরাপি যন্ত্রপাতি'
},
{
    value: 3,
    text: 'Advanced Electro Therapy Equipment',
    text_en: 'Advanced Electro Therapy Equipment',
    text_bn: 'এডভান্সড ইলেক্ট্রো থেরাপি যন্ত্রপাতি'
},
{
    value: 4,
    text: 'Accessory Therapy Equipment',
    text_en: 'Accessory Therapy Equipment',
    text_bn: 'এক্সেসরিজ বা আনুষাংগিক যন্ত্রপাতি'
},
{
    value: 5,
    text: 'Information and Technology Devices',
    text_en: 'Information and Technology Devices',
    text_bn: 'তথ্য ও প্রযুক্তি সামগ্রী'
}
]

const patientDisabilityType = [
    {
        value: 1,
        text_en: 'Physiotherapy',
        text_bn: 'ফিজিওথেরাপি'
    },
    {
        value: 2,
        text_en: 'Occupational Therapy',
        text_bn: 'অকুপেশনাল থেরাপি'
    },
    {
        value: 3,
        text_en: 'Blind',
        text_bn: 'দৃষ্টি প্রতিবন্ধী'
    },
    {
        value: 4,
        text_en: 'Speech and Language Therapy',
        text_bn: 'স্পীচ থেরাপি'
    },
    {
        value: 5,
        text_en: 'Counselling',
        text_bn: 'কাউন্সিলিং'
    },
    {
        value: 6,
        text_en: 'Hearing Impaired',
        text_bn: 'শ্রবণ প্রতিবন্ধী'
    },
    {
        value: 7,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const educationalQualificationList = [
    {
        value: 1,
        text_en: 'Illiterate',
        text_bn: 'নিরক্ষর'
    },
    {
        value: 2,
        text_en: 'Can Sign',
        text_bn: 'সাইন করতে পারেন'
    },
    {
        value: 3,
        text_en: 'Can Read',
        text_bn: 'পড়তে পারেন'
    },
    {
        value: 4,
        text_en: 'Primary',
        text_bn: 'প্রাইমারি'
    },
    {
        value: 5,
        text_en: 'Secondary',
        text_bn: 'সেকেন্ডারি'
    },
    {
        value: 6,
        text_en: 'Higher Secondary',
        text_bn: 'হাইয়ার সেকেন্ডারি'
    },
    {
        value: 7,
        text_en: 'Graduate',
        text_bn: 'গ্রাজুয়েট'
    },
    {
        value: 8,
        text_en: 'Post Graduate',
        text_bn: 'পোস্ট গ্রাজুয়েট'
    },
    {
        value: 9,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const occupationList = [
    {
        value: 1,
        text_en: 'Govt Job',
        text_bn: 'সরকারি চাকরি'
    },
    {
        value: 2,
        text_en: 'Private Job',
        text_bn: 'বেসরকারি চাকরি'
    },
    {
        value: 3,
        text_en: 'Business',
        text_bn: 'ব্যবসা'
    },
    {
        value: 4,
        text_en: 'Agriculture',
        text_bn: 'কৃষি'
    },
    {
        value: 5,
        text_en: 'Student',
        text_bn: 'ছাত্র'
    },
    {
        value: 6,
        text_en: 'Daily Labor',
        text_bn: 'দৈনিক শ্রম'
    },
    {
        value: 7,
        text_en: 'Child',
        text_bn: 'শিশু'
    },
    {
        value: 8,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const typeHouseList = [
    {
        value: 1,
        text_en: 'Tin Shed',
        text_bn: 'টিনের শেড'
    },
    {
        value: 2,
        text_en: 'Built of Brick',
        text_bn: 'ইট নির্মিত'
    },
    {
        value: 3,
        text_en: 'Built of Mud',
        text_bn: 'মাটির তৈরি'
    },
    {
        value: 4,
        text_en: 'Built of Hay',
        text_bn: 'খড় নির্মিত'
    },
    {
        value: 5,
        text_en: 'Live in rent',
        text_bn: 'ভাড়ায় থাকেন'
    },
    {
        value: 6,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const monthlyIncomeList = [
    {
        value: 1,
        text_en: 'Below 3,000 Tk',
        text_bn: '৩,০০০ টাকার নিচে'
    },
    {
        value: 2,
        text_en: '3,000 Tk – 5,000 Tk',
        text_bn: '৩,০০০ টাকা - ৫,০০০ টাকা'
    },
    {
        value: 3,
        text_en: '5,000 Tk – 10,000 Tk',
        text_bn: '৫,০০০ টাকা - ১০,০০০ টাকা'
    },
    {
        value: 4,
        text_en: '10,000 Tk – 20,000 Tk',
        text_bn: '১০,০০০ টাকা - ২০,০০০ টাকা'
    },
    {
        value: 5,
        text_en: 'Above 20,000 Tk',
        text_bn: '২০,০০০ টাকার উপরে'
    }
]

const iDInformationList = [
    {
        value: 1,
        text_en: 'NID',
        text_bn: 'এনআইডি'
    },
    {
        value: 2,
        text_en: 'Birth Reg No',
        text_bn: 'জন্ম নিবন্ধন নং'
    },
    {
        value: 3,
        text_en: 'Mobile',
        text_bn: 'মোবাইল'
    },
    {
        value: 4,
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const applicationStatusList = [
    {
        value: 1,
        text_en: 'Registered',
        text_bn: 'নিবন্ধিত'
    },
    {
        value: 2,
        text_en: 'Assigned Consultant',
        text_bn: 'নির্ধারিত পরামর্শদাতা'
    },
    {
        value: 3,
        text_en: 'Assigned Therapist',
        text_bn: 'নিযুক্ত থেরাপিস্ট'
    },
    {
        value: 4,
        text_en: 'Prescribed',
        text_bn: 'প্রেসক্রাইবড'
    }
]

const scheduleDurationTypeList = [
    {
        value: 1,
        text_en: 'Instant',
        text_bn: 'তাৎক্ষণিক'
    },
    {
        value: 2,
        text_en: 'Delayed',
        text_bn: 'বিলম্বিত'
    }
]

/** To be used in Radio Inputs */
const disabilityInformationList = [
    {
        value: 1,
        text_en: 'Persons with Disabilities',
        text_bn: 'প্রতিবন্ধী ব্যক্তি'
    },
    {
        value: 0,
        text_en: 'Persons at Risk of Disability',
        text_bn: 'প্রতিবন্ধীতার ঝুঁকিতে থাকা ব্যক্তি'
    }
]
const patientStatusList = [
    {
        value: 1,
        text_en: 'Imporve',
        text_bn: 'উন্নতি'
    },
    {
        value: 2,
        text_en: 'Stable',
        text_bn: 'স্থিতিশীল'
    },
    {
        value: 3,
        text_en: 'Deterioration',
        text_bn: 'অবনতি'
    }
]

const reasonList = [
    {
        value: 1,
        text_en: 'Treatment',
        text_bn: 'চিকিৎসা'
    },
    {
        value: 2,
        text_en: 'Counseling',
        text_bn: 'পরামর্শ'
    },
    {
        value: 3,
        text_en: 'Application of Assistive Devices',
        text_bn: 'সহায়ক উপকরণ আবেদন'
    },
    {
        value: 4,
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

export default {
    serviceTypeList,
    admissionTypeList,
    serviceOfficerComentList,
    outExpenseList,
    referList,
    consultancyReportTypeList,
    importTypeList,
    deliTypList,
    kindsDeliTypList,
    amountFmList,
    payModeList,
    mobileBankingList,
    bloodGroupList,
    centerTypeList,
    hospitalCategoryList,
    hospitalClassList,
    pMdList,
    memberTypeList,
    subServiceTypeList,
    patientTypeList,
    donationTypeList,
    donationTypeForList,
    accountTypeList,
    depositTypeList,
    socialServiceDeliveryList,
    rehabilitationInstituteList,
    identityTypeList,
    reportDurationList,
    progressReportTypeList,
    socialServiceCategoryList,
    socialServiceNameList,
    patientDisabilityType,
    educationalQualificationList,
    occupationList,
    typeHouseList,
    monthlyIncomeList,
    iDInformationList,
    applicationStatusList,
    disabilityInformationList,
    scheduleDurationTypeList,
    patientStatusList,
    vanConditionlist,
    equipmentTypeList,
    reasonList
}
